export default __webpack_public_path__ + "static/media/YAM.b633f109.svg";